import classnames from "classnames/bind";
import React from "react";
import { useTranslation } from "react-i18next";

import { useIsArcade } from "@/hooks/useIsArcade";

import { CategoryProps } from "@/interfaces/category-interface";

import styles from "./storeDirectory.module.scss";

const cx = classnames.bind(styles);

type Props = {
    category: CategoryProps;
};
const StoreDirectoryDescription: React.FC<Props> = ({
    category = {
        name: "",
        description: "",
    },
}) => {
    const { t } = useTranslation();
    const isArcade = useIsArcade();
    const { name, description } = category;
    if (!description) return null;

    const descriptionContent = `${t("category.descriptionHeaderShop")} ${name} ${t(
        "category.descriptionWithAfterpay"
    )}`;

    const categoryDescriptionContainerClassName = cx({
        [styles.categoryDescriptionContainer]: true,
        [styles.categoryDescriptionContainerArcade]: isArcade,
    });
    const categoryDescriptionContentClassName = cx({
        [styles.categoryDescriptionContent]: !isArcade,
        [styles.categoryDescriptionContentArcade]: isArcade,
    });

    return (
        <div className={categoryDescriptionContainerClassName}>
            {isArcade ? (
                <div className={styles.categoryDescriptionHeaderArcade}>{descriptionContent}</div>
            ) : (
                <h3 className={styles.categoryDescriptionHeader}>{descriptionContent}</h3>
            )}
            <div
                className={categoryDescriptionContentClassName}
                dangerouslySetInnerHTML={{ __html: description || "test" }}
            />
        </div>
    );
};

export default StoreDirectoryDescription;
